"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__png(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "document-png-mid"), /*#__PURE__*/React.createElement("g", {
    id: "f7de6169-de2b-49ab-a259-21feff9d9333",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7bc11d69-bf4d-4383-8b11-5dc3516eb574",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.53,117.81v-24h7s7-.5,7,7-7,7-7,7h-7",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,18H56c-6.63,0-14,7.37-14,14V160a14,14,0,0,0,14,14h80a14,14,0,0,0,14-14V54Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,18V50a4,4,0,0,0,4,4h32",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,108.31h5v9S112.83,122,110.86,110c-2-12.18,5.79-14.7,7.31-15.06.9-.21,6.09-.94,7.8,2.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86 117.81 86 93.81 102 117.81 102 93.81",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var _default = ic_document__png;
exports.default = _default;